
  <select #select [value]="value" (change)="OnChanges($event.value)" (click)="onTouched()">
    <option *ngIf="showEmpty" value=""></option>
    <option *ngFor="let domain of domains" [value]="domain.id">
      {{ domain.name }}
    </option>
  </select>

